import { render, staticRenderFns } from "./LawNormForm.vue?vue&type=template&id=4163fa40&scoped=true"
import script from "./LawNormForm.vue?vue&type=script&lang=js"
export * from "./LawNormForm.vue?vue&type=script&lang=js"
import style0 from "./LawNormForm.vue?vue&type=style&index=0&id=4163fa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4163fa40",
  null
  
)

export default component.exports